import { Link, useNavigate, useResolvedPath } from "react-router";
import Styles from "./header.module.css";
import { CustomNavLink } from "../customNavLink";
import { useUserStore } from "../../../hooks/store";
import {
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { stringAvatar } from "../../../utils/utils";
import { useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import NewspaperRoundedIcon from "@mui/icons-material/NewspaperRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";

export function Header() {
  const path = useResolvedPath().pathname;
  const nav = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleNav = (path) => {
    nav(path);
    setDrawerOpen(false);
  };

  const userStore = useUserStore();
  return (
    <header className={Styles.header}>
      <div className={`content ${Styles.header_content}`}>
        <div className={Styles.logo}>
          <a href="https://pyatnashka.md">
            <img
              src={`${process.env.PUBLIC_URL}/autoBrend.webp`}
              height={42}
              alt="Брендинг автошколы"
            />
          </a>
        </div>
        {/* <div onClick={handleDrawerOpen}>
          <MenuRoundedIcon className={Styles.header_burger} />
        </div> */}
        {/* <Drawer open={drawerOpen} onClose={handleDrawerClose} anchor="right">
          <CloseRoundedIcon
            sx={{
              margin: "10px 10px 0 ",
              alignSelf: "flex-end",
              width: "20px",
              height: "20px",
            }}
            onClick={handleDrawerClose}
          />
          <List>
            <nav className={`${Styles.header_nav} ${Styles.header_nav_drawer}`}>
              <ListItem onClick={() => handleNav("/")}>
                <ListItemText>
                  <CustomNavLink is_active={path == "/"} path={"/"}>
                    Главная
                  </CustomNavLink>
                </ListItemText>
                <ListItemIcon className={Styles.nav_icon}>
                  <HomeRoundedIcon />
                </ListItemIcon>
              </ListItem>
              <ListItem onClick={() => handleNav("/news")}>
                <ListItemText>
                  <CustomNavLink
                    is_active={path.includes("/news")}
                    path={"/news"}>
                    Новости
                  </CustomNavLink>
                </ListItemText>
                <ListItemIcon className={Styles.nav_icon}>
                  <NewspaperRoundedIcon />
                </ListItemIcon>
              </ListItem>
              <ListItem onClick={() => handleNav("/study/bilet")}>
                <ListItemText>
                  <CustomNavLink
                    is_active={path.includes("/study")}
                    path={"/study/bilet"}>
                    Обучение
                  </CustomNavLink>
                </ListItemText>
                <ListItemIcon className={Styles.nav_icon}>
                  <SchoolRoundedIcon />
                </ListItemIcon>
              </ListItem>
              <ListItem onClick={() => handleNav("/user")}>
                <ListItemText>
                  <CustomNavLink is_active={path == "/user"} path={"/user"}>
                    Личный кабинет
                  </CustomNavLink>
                </ListItemText>
                <ListItemIcon className={Styles.nav_icon}>
                  <AccountCircleRoundedIcon />
                </ListItemIcon>
              </ListItem>
              {userStore.isAuth ? (
                <ListItem onClick={handleClick}>
                  <ListItemText>{userStore.user}</ListItemText>
                  <ListItemIcon className={Styles.nav_icon}>
                    <Avatar
                      {...stringAvatar(userStore.user)}
                      style={{
                        width: "30px",
                        height: "30px",
                        fontSize: "1rem",
                        fontFamily: "Inter !important",
                      }}
                    />
                  </ListItemIcon>
                </ListItem>
              ) : (
                <button
                  onClick={() => {
                    nav("/login");
                  }}>
                  войти
                </button>
              )}
            </nav>
          </List>
        </Drawer>
        <nav className={Styles.header_nav}>
          <CustomNavLink is_active={path == "/"} path={"/"}>
            Главная
          </CustomNavLink>
          <CustomNavLink is_active={path.includes("/news")} path={"/news"}>
            Новости
          </CustomNavLink>
          <CustomNavLink
            is_active={path.includes("/study")}
            path={"/study/bilet"}>
            Обучение
          </CustomNavLink>
          <CustomNavLink is_active={path == "/user"} path={"/user"}>
            Личный кабинет
          </CustomNavLink>

          {userStore.isAuth ? (
            <Avatar
              onClick={handleClick}
              {...stringAvatar(userStore.user)}
              style={{ fontSize: "1rem", fontFamily: "Inter !important" }}
            />
          ) : (
            <button
              onClick={() => {
                nav("/login");
              }}>
              войти
            </button>
          )}
        </nav> */}
      </div>

      {/* <Menu
        sx={{ width: "300px" }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
        <MenuItem
          onClick={() => {
            handleClose();
            userStore.logout();
            nav(0);
          }}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText>Выйти</ListItemText>
        </MenuItem>
      </Menu> */}
    </header>
  );
}
